import salesPlans from '@/components/sales-plans/SalesPlans'

export default [
  {
    path: '/salesPlans',
    name: 'salesPlans',
    component: salesPlans,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/salesPlans.js